export default "__VITE_ASSET__BCxXx55r__"